import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import styled from 'styled-components';
import { StyledLinkProps, styledLink } from './StyledLink';

/* eslint-disable @typescript-eslint/no-unused-vars */
const StyledRouterLink = styled(
    ({
        linkColor,
        linkFontFamily,
        noUnderline,
        size = 'inherit',
        forwardedRef,
        ...props
    }: StyledLinkProps &
        RouterLinkProps & { forwardedRef?: React.RefAttributes<HTMLAnchorElement>['ref'] }) => (
        <RouterLink ref={forwardedRef} {...props} />
    )
)<StyledLinkProps>(styledLink);
/* eslint-enable @typescript-eslint/no-unused-vars */

export default StyledRouterLink;
